<template>
  <transition name="fade" v-if="!done">
    <div class="alert alert--error">
      <strong>ลบรายการแล้ว:</strong>
      <span class="product__desc">
        {{ product.name }}
        {{ subSkuSummary }}
        ({{ quantity }} รายการ)
      </span>
      <a class="edit-action undo-action" href="#" @click.prevent="undo">ย้อนกลับ</a>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UndoRemove',
  props: {
    product: {
      type: Object,
      required: true
    },
    attributes: {
      type: Object,
      required: false
    },
    quantity: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      done: false
    }
  },
  computed: {
    subSkuSummary () {
      if (Object.keys(this.attributes).length === 0) {
        return ''
      }
      return '(' + this.$utils.getProductSubSku(this.product, this.attributes).replace(/_/g, ' / ') + ')'
    }
  },
  methods: {
    undo () {
      if (this.done) {
        return
      }
      this.done = true
      this.$utils.addToCart(this.product, this.attributes, this.quantity)
      this.$emit('undo', this.product, this.attributes)
      this.$utils.fbTrack('undoRemoveFromCart', this.quantity, { sku: this.product.sku })
    }
  }
}
</script>



// WEBPACK FOOTER //
// UndoRemove.vue?6a21e662